import { unitMapping } from 'lib/style';

type Props = {
  size?: keyof typeof unitMapping;
  className?: string;
};

export const Dollar = ({ size = 2, className }: Props) => {
  return (
    <svg
      style={{ width: unitMapping[size], height: unitMapping[size] }}
      viewBox="0 0 8 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M6.31822 5.22273L7.64095 6.54545V8.85L6.19549 10.2955H4.87277V12H3.40004V10.2955H1.70913L0.359131 8.94546L1.69549 7.60909L2.67731 8.59091H5.21368L5.67731 8.12727V7.26818L5.3364 6.92727L1.95459 6.70909L0.631858 5.38636V3.15L2.07731 1.70455H3.40004V0H4.87277V1.70455H6.29095L7.60004 3.01364L6.26368 4.35L5.32277 3.40909H3.05913L2.59549 3.87273V4.66364L2.9364 5.00455L6.31822 5.22273Z"
        fill="url(#paint0_linear_11575_17754)"
      />
      <defs>
        <linearGradient
          id="paint0_linear_11575_17754"
          x1="6.95109"
          y1="13.5"
          x2="1.22575"
          y2="8.84898"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F1FF00" />
          <stop offset="1" stopColor="#3DDC84" />
        </linearGradient>
      </defs>
    </svg>
  );
};
